import clip from 'text-clipper';

import { Image } from '@axis/components/Image';
import { Link } from '@axis/components/Link';
import {
  ProductContentSmallFragment, SimpleProduct,
} from '@axis/graphql';
import { useIsMobile } from '@axis/hooks/mobile';

export interface ProductCardProps {
  product: ProductContentSmallFragment
}
export function ProductCard({ product }: ProductCardProps) {
  const description = clip(
    product?.shortDescription as string,
    60,
    {
      html: true,
      maxLines: 2,
      breakWords: true,
    },
  );

  return (
    <Link
      className="product-card
    max-w-[16rem]
    md:max-w-none
    min-w-[16rem]
    no-underline
    text-inherit
    flex
    flex-col
    min-h-full
    justify-start
    items-center
    relative
    rounded
    overflow-hidden
    hover:shadow-lg
    bg-cornsilk-300
    transition-shadow
    duration-500"
      id={product.slug as string}
      href={`/shop/${product.slug}`}
    >
      {product?.image && (
        <Image
          className="bg-gray-200
          h-full
          min-h-[16rem]
          relative
          aspect-w-1
          aspect-h-1
          xl:aspect-w-7
          xl:aspect-h-8
          mb-3"
          src={product.image?.thumbnailUrl as string}
          alt={product.image?.altText as string}
          sizes={product.image?.sizes as string}
        />
      )}
      <div className="product-card-content
      w-full
      max-h-[10rem]
      h-64
      px-6
      py-4
      flex
      flex-col
      justify-between"
      >
        <div className="title font-serif font-bold text-xl mb-0">{product?.name as string}</div>
        <div className="description font-sans text-sm" dangerouslySetInnerHTML={{ __html: description }} />
        <span className="price mt-auto justify-self-end font-sans font-semibold text-lg">{(product as SimpleProduct)?.price as string}</span>
      </div>
    </Link>
  );
}
